import { defineClient } from '@/services/api';

const endpoint = '/api/queue'
const apiClient = defineClient(endpoint);

export default {
    // Define the functions to insert queue with the API
    async putIntoQueue(data, path = '') {
        return await apiClient.post(path, data);
    },
    // Define the functions to get all queue with the API
    async getQueueAll(query='') {
        return await apiClient.get('/list' + query);
    },
    // Define the functions to send email with the API
    async sendEmail(data) {
        return await apiClient.post('/send-email', data);
    },
    // Define the function to delete a queue record by its id
    async deleteFromQueue(id) {
        return await apiClient.delete('/' + id);
    },

    async parseBadge(data) {
        return await apiClient.post("/parse-badge", data);
    },
};